import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../.services/settings.service';


@Component({
  selector: 'app-feedback-form',
  templateUrl: './feedback-form.component.html',
  styleUrls: ['./feedback-form.component.css']
})
export class FeedbackFormComponent implements OnInit {

  settings: SettingsService;

  CLIENT_SECRET = "V9AmMuNnAlYphCv5ncAg3boFv2q05m*3";
  CLIENT_ID = "fa84a53c-39b2-11e8-a6b7-ac1ff8470000";

  name: string;
  email: string;
  subject: string;
  message: string;
  severity: string;
  formOpen: boolean = false;
 

  constructor(settingsService: SettingsService) { 
    this.settings = settingsService;
    this.severity = "Low";
  }


  createTicket  = () => {
    let ticket = {
      "TICKETS": [
        {
          "SUBJECT": this.subject,
          "TICKET_MESSAGES": {
            "BODY": this.message,
            "IS_INTERNAL": "N"
          },
          "DATE_REQUIRED_BY": "",
          "SEVERITY": this.severity,
          "SOURCE": "API",
          "STATUS": "NEW"
        }
      ]
    }
    return(ticket)
  }

  submitForm = () => {
    let ticket = this.createTicket();
    
    fetch(`https://api.ngdesk.com/v2/operations/tickets?
          client_secret=${this.CLIENT_SECRET}&
          client_id=${this.CLIENT_ID}`, {
      method: 'post',
      body: JSON.stringify(ticket)
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      //console.log(data)
      
    });

  }

  toggleForm = () => {
    this.settings.toggleReportForm();
  }

  ngOnInit() {


    this.settings.bugReportFormOpenCast.subscribe((setting)=> {
      this.formOpen = setting;
    });

    //var subdomain = "enlighten";
   //document.getElementById('feedback').insertAdjacentHTML( 'beforeend', '<iframe id="feedback" src="https://download.ngdesk.com/TicketWidget?subdomain=' + subdomain + '" scrolling="no" style="border:none;min-width:500px;min-height:700px;"></iframe>');
 
  }

}
//V9AmMuNnAlYphCv5ncAg3boFv2q05m*3